import React, { useEffect, useRef } from 'react';
import API_URL from '@/config/api';

export const marketingPhotoUrl = (p) => `${API_URL}/api/marketing/photo/${p.source}/${p.owner_id}/${p.ref}/${p.id}`;

const load = (src) => new Promise((res, rej) => { const img = new Image(); img.crossOrigin = 'anonymous'; img.onload = () => res(img); img.onerror = rej; img.src = src; });
const cover = (ctx, img, x, y, w, h) => { const r = Math.max(w / img.width, h / img.height); const sw = w / r, sh = h / r; ctx.drawImage(img, (img.width - sw) / 2, (img.height - sh) / 2, sw, sh, x, y, w, h); };

/** Canvas composer: single photo or before/after collage, optional watermark (business name + "Ox Resin approved installer"), optional shared-photo credit. */
export function PostCanvas({ photos, watermark, business, credit, onReady }) {
  const ref = useRef(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      const c = ref.current; if (!c || !photos.length) return;
      const W = 1080, H = 1080; c.width = W; c.height = H;
      const ctx = c.getContext('2d');
      ctx.fillStyle = '#111'; ctx.fillRect(0, 0, W, H);
      try {
        const imgs = await Promise.all(photos.slice(0, 2).map((p) => load(marketingPhotoUrl(p))));
        if (!alive) return;
        if (imgs.length === 2) {
          cover(ctx, imgs[0], 0, 0, W / 2 - 4, H); cover(ctx, imgs[1], W / 2 + 4, 0, W / 2 - 4, H);
          const tag = (t, x) => { ctx.fillStyle = 'rgba(0,0,0,.65)'; ctx.fillRect(x, 40, 220, 64); ctx.fillStyle = '#fff'; ctx.font = 'bold 34px sans-serif'; ctx.textAlign = 'center'; ctx.fillText(t, x + 110, 85); };
          tag('BEFORE', 40); tag('AFTER', W / 2 + 44);
        } else cover(ctx, imgs[0], 0, 0, W, H);
        if (watermark) {
          const grad = ctx.createLinearGradient(0, H - 220, 0, H); grad.addColorStop(0, 'rgba(0,0,0,0)'); grad.addColorStop(1, 'rgba(0,0,0,.75)');
          ctx.fillStyle = grad; ctx.fillRect(0, H - 220, W, 220);
          ctx.textAlign = 'left'; ctx.fillStyle = '#fff'; ctx.font = 'bold 44px sans-serif'; ctx.fillText(business || 'Your business', 48, H - 92);
          ctx.font = '28px sans-serif'; ctx.fillStyle = '#7dd3fc'; ctx.fillText('Ox Resin approved installer', 48, H - 48);
        }
        if (credit) { ctx.textAlign = 'right'; ctx.fillStyle = 'rgba(255,255,255,.85)'; ctx.font = '22px sans-serif'; ctx.fillText(`Photo: ${credit}`, W - 32, 44); }
        onReady?.(c);
      } catch { /* image blocked */ }
    })();
    return () => { alive = false; };
  }, [photos, watermark, business, credit]); // eslint-disable-line react-hooks/exhaustive-deps
  return <canvas ref={ref} className="w-full rounded-xl border border-slate-200 bg-slate-900" data-testid="mh-canvas" />;
}
